import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const STATEMENT_SUMMARY_SCHEMA = Object.freeze({
  INVOICES: 0,
  PAYMENTS: 0,
  BALANCE: 0,
  CREDIT_MEMOS: 0,
});
const RECORD = generateSchema(STATEMENT_SUMMARY_SCHEMA);
const KEYS: any = generateKeys(STATEMENT_SUMMARY_SCHEMA);

export class StatementSummary extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get invoices(): number {
    return this.get(KEYS.INVOICES);
  }

  get payments(): number {
    return this.get(KEYS.PAYMENTS);
  }

  get balance(): number {
    return this.get(KEYS.BALANCE);
  }

  get creditMemos(): number {
    return this.get(KEYS.CREDIT_MEMOS);
  }
}
